import * as types from "../actions/actionsTypes";
import initialState from "./initialState";

export default function quizDataReducer(state = initialState.quizData, action) {
  switch (action.type) {
    case types.LOADED_QUIZ_DATA_SUCCESS:
      return action.quizData;
    default:
      return state;
  }
}
